import { render } from "./xuenjiajilu.vue?vue&type=template&id=54b908f0&scoped=true"
import script from "./xuenjiajilu.vue?vue&type=script&lang=js"
export * from "./xuenjiajilu.vue?vue&type=script&lang=js"

import "./xuenjiajilu.vue?vue&type=style&index=0&id=54b908f0&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b908f0"]])

export default __exports__